import React from 'react';
import { FlagIcon, InstagramIcon, MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="w-full bg-neutral-950 border-t border-neutral-800 py-16 px-4" data-id="element-185">
      <div className="max-w-7xl mx-auto" data-id="element-186">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12" data-id="element-187">
          {/* Brand */}
          <div data-id="element-188">
            <div className="flex items-center gap-2 mb-4" data-id="element-189">
              <img src="https://cdn.magicpatterns.com/uploads/bXrefJ2oBh4YLN5nxqUgzp/PHOTO-2024-12-29-00-15-52.jpg" alt="Motomaniac Logo" className="h-16 w-auto object-contain rounded-lg border border-orange-500/20" data-id="element-190" />
            </div>
            <p className="text-gray-400 text-sm mb-4" data-id="element-191">
              {t('footer.description')}
            </p>
            <p className="text-gray-500 text-xs" data-id="element-192">{t('footer.tagline')}</p>
          </div>

          {/* Quick Links */}
          <div data-id="element-193">
            <h4 className="font-bold text-white text-sm uppercase tracking-wider mb-4" data-id="element-194">
              {t('footer.quickLinks')}
            </h4>
            <div className="space-y-3" data-id="element-195">
              <a href="#classes" className="block text-gray-400 hover:text-orange-500 text-sm transition-colors" data-id="element-196">
                {t('footer.racingClasses')}
              </a>
              <a href="#map" className="block text-gray-400 hover:text-orange-500 text-sm transition-colors" data-id="element-197">
                {t('footer.competitionMap')}
              </a>
              <a href="#info" className="block text-gray-400 hover:text-orange-500 text-sm transition-colors" data-id="element-198">
                {t('footer.raceInfo')}
              </a>
              <a href="#register" className="block text-gray-400 hover:text-orange-500 text-sm transition-colors" data-id="element-199">
                {t('footer.registration')}
              </a>
              <a href="#gallery" className="block text-gray-400 hover:text-orange-500 text-sm transition-colors" data-id="element-200">
                {t('footer.photoGallery')}
              </a>
            </div>
          </div>

          {/* Contact */}
          <div data-id="element-201">
            <h4 className="font-bold text-white text-sm uppercase tracking-wider mb-4" data-id="element-202">
              {t('footer.contact')}
            </h4>
            <div className="space-y-3" data-id="element-203">
              <a href="mailto:info@motomaniac.lv" className="flex items-center gap-2 text-gray-400 hover:text-orange-500 text-sm transition-colors" data-id="element-204">
                <MailIcon className="h-4 w-4 flex-shrink-0" data-id="element-205" />
                info@motomaniac.lv
              </a>
              <a href="tel:+37120000000" className="flex items-center gap-2 text-gray-400 hover:text-orange-500 text-sm transition-colors" data-id="element-206">
                +371 2628 3759
              </a>
              <div className="flex items-start gap-2 text-gray-400 text-sm" data-id="element-207">
                <MapPinIcon className="h-4 w-4 flex-shrink-0 mt-0.5" data-id="element-208" />
                <span data-id="element-209">Pāvuli, Raunas pagasts, Smiltenes novads, Latvija</span>
              </div>
            </div>
          </div>

          {/* Social & Newsletter */}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-neutral-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-210">
          <p className="text-gray-500 text-xs" data-id="element-211">{t('footer.copyright')}</p>
          <div className="flex items-center gap-6" data-id="element-212">
            <a href="#" className="text-gray-500 hover:text-gray-300 text-xs transition-colors" data-id="element-213">
              {t('footer.privacyPolicy')}
            </a>
            <a href="#" className="text-gray-500 hover:text-gray-300 text-xs transition-colors" data-id="element-214">
              {t('footer.termsConditions')}
            </a>
            <a href="#" className="text-gray-500 hover:text-gray-300 text-xs transition-colors" data-id="element-215">
              {t('footer.raceRules')}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}